var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplaceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5479 0.181641H2.20318C1.08578 0.181641 0.181641 1.08578 0.181641 2.20318V11.5479C0.181641 12.6623 1.08578 13.5665 2.20318 13.5695H11.5479C12.6623 13.5695 13.5665 12.6653 13.5695 11.5479V2.20318C13.5695 1.08878 12.6653 0.184644 11.5479 0.181641ZM0.782395 2.20318C0.782395 1.41919 1.41919 0.785399 2.20318 0.782395H11.5479C12.3319 0.782395 12.9657 1.41919 12.9687 2.20318V8.90159L10.854 7.02123C10.7339 6.91309 10.5477 6.92211 10.4365 7.03925L8.44201 9.13288L6.48055 7.04226C6.42348 6.98218 6.34538 6.94914 6.26428 6.94614C6.18318 6.94614 6.10508 6.97918 6.04801 7.03925L1.00768 12.3049C0.860493 12.0796 0.782395 11.8153 0.782395 11.5449V2.20318ZM1.42821 12.7344L6.25527 7.68206L11.2115 12.9657H2.20318C1.92683 12.9657 1.6595 12.8846 1.43121 12.7344H1.42821ZM11.9684 12.8936L8.85053 9.57143L10.6678 7.66404L12.9657 9.7066V11.5479C12.9657 12.1667 12.5602 12.7134 11.9684 12.8966V12.8936Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.365122
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93023 5.66709C8.75026 5.66709 9.41709 5.00026 9.41709 4.18023C9.41709 3.3602 8.75026 2.69336 7.93023 2.69336C7.1102 2.69336 6.44336 3.3602 6.44336 4.18023C6.44336 5.00026 7.1102 5.66409 7.93023 5.66709ZM7.93023 3.29712C8.41984 3.29712 8.81634 3.69362 8.81634 4.18323C8.81634 4.67285 8.41984 5.06934 7.93023 5.06934C7.44061 5.06934 7.04411 4.67285 7.04411 4.18323C7.04411 3.69362 7.44061 3.29712 7.93023 3.29712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.365122
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceLogo);
export default __webpack_public_path__ + "static/media/ReplaceLogo.9f7c6bce328c03b56c322868d4619d9a.svg";
export { ForwardRef as ReactComponent };